import script from "./sponsorships.vue?vue&type=script&setup=true&lang=js"
export * from "./sponsorships.vue?vue&type=script&setup=true&lang=js"

import "./sponsorships.vue?vue&type=style&index=0&id=21d12ff4&lang=scss&scoped=true"
script.__scopeId = "data-v-21d12ff4"

export default script